import i18next from 'i18next'
import { Button } from 'primereact/button'
import { OverlayPanel } from 'primereact/overlaypanel'
import { MouseEvent, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface CompProps {
  handleExport: () => void
}

export default function ExportBtn({ handleExport }: CompProps) {
  const { t } = useTranslation()
  const lang = i18next.language
  const addToExcel = useRef<OverlayPanel>(null)
  const showExcel = (e: MouseEvent<HTMLButtonElement>) => addToExcel.current?.show(e, e.target)

  return (
    <ButtonWrapper lang={lang}>
      <Button
        onMouseOver={(e) => showExcel(e)}
        onMouseLeave={() => addToExcel.current?.hide()}
        className="p-button-plain p-button-rounded p-button-text export-btn"
        onClick={handleExport}>
        <i className="pi pi-file-excel excelIcon" style={{ fontSize: '20px', cursor: 'pointer' }}></i>
      </Button>

      <OverlayPanel ref={addToExcel} className="add-excel-panel">
        <div className="add-excel-text">
          <p>{t('overlaypanel-texts.export-excel')}</p>
        </div>
      </OverlayPanel>
    </ButtonWrapper>
  )
}

const ButtonWrapper = styled.div<{ lang: string }>`
  position: relative;
  .export-btn {
    z-index: 123;
    position: absolute;
    top: -3px;
    right: ${({ lang }) => (lang === 'tr' ? '152px' : '195px')};
    padding: 0.5rem !important;
  }
`
